import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axiosInstance from "apiHandles/axiosInstance";
import { getSubSave, } from "../apiHandles/user_progress";
import TreeIcon from "../assets/img/tree.svg"
import SetIcon from "../assets/img/set symbol.svg"
import "../assets/css/argon-dashboard-react.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GreekTranslate } from "./translation.js"
import {
  faTree,
  faProjectDiagram,
  faList,
  faTh,
  faHashtag,
  faArrowUp,
  faArrowDown,
  faPercent,
  faTimes,
  faFileLines,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "context/LanguageProvider";
import CryptoJS from 'crypto-js';
import { useDarkMode } from "context/DarkModeProvider";
import { faPython } from "@fortawesome/free-brands-svg-icons";

const StructureModal = ({ isOpen, toggle, structureName, subcategories, structures, substructures }) => {
  const [subStructuresSave, setsubStructuresSave] = useState([]);
  const [subSaveProgressions, setSubSaveProgressions] = useState({});
  const [success, setSuccess] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();

  const { darkMode } = useDarkMode();


  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  // Color schemes - Enhanced για light mode
  const colorSchemes = {
    HashTable: {
      primary: '#10b981',
      secondary: '#059669',
      accent: '#d1fae5',
      lightBg: '#f0fdf4',
      lightBorder: '#bbf7d0'
    },
    Tree: {
      primary: '#3b82f6',
      secondary: '#2563eb',
      accent: '#dbeafe',
      lightBg: '#eff6ff',
      lightBorder: '#bfdbfe'
    },
    List: {
      primary: '#8b5cf6',
      secondary: '#7c3aed',
      accent: '#ede9fe',
      lightBg: '#faf5ff',
      lightBorder: '#e9d5ff'
    },
    Stack: {
      primary: '#f59e0b',
      secondary: '#d97706',
      accent: '#fef3c7',
      lightBg: '#fffbeb',
      lightBorder: '#fde68a'
    },
    Queue: {
      primary: '#ef4444',
      secondary: '#dc2626',
      accent: '#fecaca',
      lightBg: '#fef2f2',
      lightBorder: '#fecaca'
    },
    Graph: {
      primary: '#06b6d4',
      secondary: '#0891b2',
      accent: '#cffafe',
      lightBg: '#ecfeff',
      lightBorder: '#a5f3fc'
    },
    Array: {
      primary: '#ec4899',
      secondary: '#db2777',
      accent: '#fce7f3',
      lightBg: '#fdf2f8',
      lightBorder: '#fbcfe8'
    },
    Set: {
      primary: '#84cc16',
      secondary: '#65a30d',
      accent: '#ecfccb',
      lightBg: '#f7fee7',
      lightBorder: '#d9f99d'
    },
    Python: {
      primary: "#3776ab",
      secondary: '#ffd43b',
      accent: '#e8f0f8',
      lightBg: '#f0f6ff',
      lightBorder: '#b3cce8'   // ← αυτό λύνει το πρόβλημα
    }
  };



  const iconMap = {
    Graph: faProjectDiagram,
    List: faList,
    Array: faTh,
    Stack: faArrowUp,
    Queue: faArrowDown,
    HashTable: faHashtag,
    Python: faPython
  };

  const scheme = colorSchemes[structureName] || colorSchemes.Graph;
  const unwantedicons = ["Tree", "Set"];

  const needsScrolling = subcategories && subcategories.length >= 3;

  const SECRET_KEY = process.env.REACT_APP_STRIPE_ENCRYPTION_SECRET_KEY
  function decryptData(encryptedData) {
    try {
      const key = CryptoJS.SHA256(SECRET_KEY);

      const decrypted = CryptoJS.AES.decrypt(
        encryptedData,
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );

      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedString);
    } catch (error) {
      console.error("Decryption failed:", error);
      return null;
    }
  }

  const fetchSubStructuresSave = async () => {
    try {
      const response = await axiosInstance.get("/user/substructuresave/");

      const decryptedData = decryptData(response.data.data);
      setsubStructuresSave(decryptedData);

    } catch (error) {
      if (error.response?.status === 401) {
        alert(selLanguage ? "Πρέπει να κάνεις login ξανά" : "You need to login again");
        localStorage.removeItem("access");
        navigate("/login");
      } else if (error.response?.status === 403) {
        alert(selLanguage ? "CSRF error. Δοκίμασε ξανά." : "CSRF error. Please try again.");
      } else {
        alert("PROBLEM: " + error.message);
      }
    }
  };

  const getStructureId = (structureName) => {
    const structure = structures.find(item => item.name === structureName);
    return structure ? structure.id : null;
  };

  const getSavesOfStructure = (structureName) => {
    const structureId = getStructureId(structureName);
    return subStructuresSave.filter(item => item.parent_structureSave === structureId);
  };

  const handleSubcategoryClick = (subcategory) => {
    localStorage.setItem("substrcutureLocation", subcategory.name);
    localStorage.setItem("SubCategoryClicked", JSON.stringify(subcategory))
    var sub = subcategory.name;

    if (sub.toLowerCase() === "general") {
      navigate("/general");
    } else {
      navigate(`/structure/${structureName}/${subcategory.id}`)
    }

    toggle();
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchSubStructuresSave();

      const progressData = {};
      for (const sub of subcategories) {
        try {
          if (sub.name !== "General") {
            const progress = await getSubSave(sub.name);
            progressData[sub.name] = progress;
          }
        } catch (err) {
          progressData[sub.name] = 0;
        }
      }
      setSubSaveProgressions(progressData);
      setSuccess(true);
    };

    loadData();
  }, [subcategories]);

  const getProgressWidth = (value) => {
    if (value > 100) return "100%";
    if (value >= 96) return "100%";

    if (value === 0) return "0%";
    const minWidth = 8;
    return Math.max(value, minWidth) + "%";
  };

  return (
    <>
      {/* Custom backdrop */}
      {isOpen && (
        <div
          className="modal-backdrop"
          style={{
            width: '100%',
            height: '100%',
            background: darkMode ? 'rgba(0, 0, 0, 0.6)' : 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(8px)',
            zIndex: 1040,
          }}
          onClick={toggle}
        />
      )}

      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        style={{ zIndex: 1050, width: "100%", maxWidth: "600px", padding: "0 16px" }}
        contentClassName="border-0 shadow-none"
      >
        <div
          style={{
            background: darkMode
              ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
              : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            borderRadius: '24px',
            border: darkMode
              ? `1px solid ${scheme.primary}30`
              : `2px solid ${scheme.lightBorder}`,
            boxShadow: darkMode
              ? `0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px ${scheme.primary}20`
              : `0 20px 40px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px ${scheme.primary}15`,
            overflow: 'hidden',
            position: 'relative',
            width: '100%',
            maxWidth: '600px',
            height: needsScrolling ? "90vh" : "auto",
            maxHeight: needsScrolling ? "90vh" : "none",
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* Header */}
          <div
            style={{
              background: darkMode
                ? `linear-gradient(135deg, ${scheme.primary}20 0%, ${scheme.secondary}15 100%)`
                : `linear-gradient(135deg, ${scheme.lightBg} 0%, ${scheme.accent} 100%)`,
              padding: '32px 32px 24px',
              position: 'relative',
              borderBottom: darkMode
                ? `1px solid ${scheme.primary}20`
                : `1px solid ${scheme.lightBorder}`,
              flexShrink: 0
            }}
          >
            {/* Close button */}
            <button
              onClick={toggle}
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.9)',
                border: darkMode ? 'none' : `1px solid ${scheme.lightBorder}`,
                borderRadius: '12px',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                boxShadow: darkMode ? 'none' : '0 2px 8px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.background = darkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(255, 255, 255, 1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.background = darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.9)';
              }}
            >
              <FontAwesomeIcon
                icon={faTimes}
                style={{
                  color: darkMode ? '#fff' : '#334155',
                  fontSize: '16px'
                }}
              />
            </button>

            {/* Structure icon */}
            <div
              style={{
                width: '80px',
                height: '80px',
                background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
                borderRadius: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                boxShadow: darkMode
                  ? `0 8px 25px -5px ${scheme.primary}40`
                  : `0 8px 20px -5px ${scheme.primary}50`,
              }}
            >
              {!unwantedicons.includes(structureName) && (
                <FontAwesomeIcon
                  icon={iconMap[structureName]}
                  style={{
                    fontSize: '32px',
                    color: 'white',
                  }}
                />
              )}
              {structureName === "Tree" && (
                <img src={TreeIcon} alt="Tree Icon" style={{ width: '36px', height: '36px' }} />
              )}
              {structureName === "Set" && (
                <img src={SetIcon} alt="Set Icon" style={{ width: '36px', height: '36px' }} />
              )}
            </div>

            {/* Title */}
            <h3
              style={{
                textAlign: 'center',
                fontWeight: '700',
                margin: '0',
                fontSize: '24px',
                fontFamily: '"Inter", "Poppins", sans-serif',
                background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {selLanguage
                ? "Υποδομές " + GreekTranslate[structureName]
                : structureName + " Substructures"}
            </h3>
          </div>

          {/* Body */}
          <div
            style={{
              padding: '32px',
              flex: needsScrolling ? '1 1 0' : 'none',
              overflow: needsScrolling ? 'auto' : 'visible',
              minHeight: 0
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {[...subcategories]
                .sort((a, b) => (a.name === "General" ? -1 : b.name === "General" ? 1 : 0))
                .map((item, i) => {
                  const progress = subSaveProgressions[item.name] || 0;
                  const isHovered = hoveredIndex === i;
                  const isGeneral = item.name === "General";

                  return (
                    <div
                      key={i}
                      onMouseEnter={(e) => {
                        setHoveredIndex(i);
                      }}
                      onMouseLeave={() => setHoveredIndex(null)}
                      onClick={() => handleSubcategoryClick(item)}
                      style={{
                        position: 'relative',
                        background: darkMode
                          ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)'
                          : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                        border: darkMode
                          ? '1px solid rgba(255, 255, 255, 0.1)'
                          : `1px solid ${isHovered ? scheme.primary : scheme.lightBorder}`,
                        borderRadius: '16px',
                        padding: '20px',
                        cursor: 'pointer',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: isHovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)',
                        boxShadow: isHovered
                          ? darkMode
                            ? `0 0px 10px ${scheme.primary}30`
                            : `0 0px 10px ${scheme.primary}40`
                          : darkMode
                            ? 'none'
                            : 'none',
                        overflow: 'hidden',
                      }}
                    >
                      {/* Background glow effect */}
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          background: `radial-gradient(circle at center, ${scheme.primary}${darkMode ? '10' : '08'} 0%, transparent 70%)`,
                          opacity: isHovered ? 1 : 0,
                          transition: 'opacity 0.3s ease',
                        }}
                      />

                      {/* Content */}
                      <div style={{ position: 'relative', zIndex: 2 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: !isGeneral ? '12px' : '0' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {isGeneral && (
                              <div
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  background: `linear-gradient(135deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
                                  borderRadius: '10px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: `0 4px 12px ${scheme.primary}30`,
                                }}
                              >
                                <FontAwesomeIcon icon={faFileLines} style={{ color: 'white', fontSize: '19px' }} />
                              </div>
                            )}

                            <h4
                              style={{
                                fontSize: '18px',
                                fontWeight: '600',
                                margin: '0',
                                color: darkMode
                                  ? (isHovered ? '#fff' : '#e2e8f0')
                                  : (isHovered ? '#0f172a' : '#334155'),
                                fontFamily: '"Inter", "Poppins", sans-serif',
                                letterSpacing: '0.3px',
                              }}
                            >
                              {selLanguage ? (GreekTranslate[item.name] ?? "Ανοιχτή Διευθυνσιοδότηση") : item.name}
                            </h4>
                          </div>

                          {!isGeneral && progress > 0 && (
                            <span
                              style={{
                                fontSize: '14px',
                                fontWeight: '700',
                                color: scheme.primary,
                                fontFamily: '"Inter", sans-serif',
                              }}
                            >
                              {Math.round(progress) >= 96 ? "100" : Math.round(progress)}%
                            </span>
                          )}
                        </div>

                        {/* Progress bar */}
                        {!isGeneral && (
                          <div
                            style={{
                              width: '100%',
                              height: '6px',
                              backgroundColor: darkMode
                                ? 'rgba(255, 255, 255, 0.1)'
                                : scheme.lightBorder,
                              borderRadius: '10px',
                              overflow: 'hidden',
                              position: 'relative',
                            }}
                          >
                            <div
                              style={{
                                width: getProgressWidth(progress),
                                height: '100%',
                                background: `linear-gradient(90deg, ${scheme.primary} 0%, ${scheme.secondary} 100%)`,
                                borderRadius: '10px',
                                transition: 'all 0.7s ease-out',
                                boxShadow: `0 0 8px ${scheme.primary}40`,
                              }}
                            />
                          </div>
                        )}

                        {isGeneral && (
                          <p
                            style={{
                              fontSize: '14px',
                              color: darkMode ? 'rgba(255, 255, 255, 0.6)' : '#64748b',
                              margin: '8px 0 0',
                              fontFamily: '"Inter", sans-serif',
                            }}
                          >
                            {selLanguage ? "Ξεκίνα με τα βασικά" : "Start with the basics"}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </Modal>

      {/* CSS */}
      <style>{`
        .modal-content {
          background: transparent !important;
          border: none !important;
        }
        
        div[style*="overflow: auto"]::-webkit-scrollbar {
          width: 8px;
        }
        
        div[style*="overflow: auto"]::-webkit-scrollbar-track {
          background: ${darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
          border-radius: 10px;
        }
        
        div[style*="overflow: auto"]::-webkit-scrollbar-thumb {
          background: ${scheme.primary}60;
          border-radius: 10px;
          transition: background 0.3s ease;
        }
        
        div[style*="overflow: auto"]::-webkit-scrollbar-thumb:hover {
          background: ${scheme.primary}80;
        }
      `}</style>
    </>
  );
};

export default StructureModal;